// // ===============================================
// // Purchase Service API Client
// // สำหรับเชื่อมต่อกับ Backend Purchase APIs
// // ===============================================
// import { Search } from 'lucide-react';
// import api from '../utils/api';

// // ===============================================
// // Purchase API Functions
// // ===============================================

// export const purchasesAPI = {
//   /**
//    * ดึงรายการใบสั่งซื้อทั้งหมด
//    * @param {Object} params - ตัวกรองข้อมูล
//    * @returns {Promise}
//    */
//   getAll: async (params = {}) => {
//     try {
//       const response = await api.get('/api/purchases', { params });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * ดึงรายละเอียดใบสั่งซื้อเฉพาะ
//    * @param {string|number} id - ID ของใบสั่งซื้อ
//    * @returns {Promise}
//    */
//   getById: async (id) => {
//     try {
//       const response = await api.get(`/api/purchases/${id}`);
//       console.log('response', response);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * สร้างใบสั่งซื้อใหม่
//    * @param {Object} purchaseData - ข้อมูลใบสั่งซื้อ
//    * @returns {Promise}
//    */
//   create: async (purchaseData) => {
//     try {
//       const response = await api.post('/api/purchases/orders', purchaseData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * แก้ไขใบสั่งซื้อ
//    * @param {string|number} id - ID ของใบสั่งซื้อ
//    * @param {Object} purchaseData - ข้อมูลใบสั่งซื้อที่จะแก้ไข
//    * @returns {Promise}
//    */
//   update: async (id, purchaseData) => {
//     try {
//       const response = await api.put(`/api/purchases/orders/${id}`, purchaseData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * เปลี่ยนสถานะใบสั่งซื้อ
//    * @param {string|number} id - ID ของใบสั่งซื้อ
//    * @param {string} status - สถานะใหม่
//    * @param {string} notes - หมายเหตุ
//    * @returns {Promise}
//    */
//   updateStatus: async (id, status, notes = '') => {
//     try {
//       const response = await api.patch(`/api/purchases/${id}/status`, {
//         status,
//         notes
//       });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * ลบใบสั่งซื้อ
//    * @param {string|number} id - ID ของใบสั่งซื้อ
//    * @returns {Promise}
//    */
//   delete: async (id) => {
//     try {
//       const response = await api.delete(`/api/purchases/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * รับสินค้าเข้าคลัง
//    * @param {string|number} id - ID ของใบสั่งซื้อ
//    * @param {Object} receiveData - ข้อมูลการรับสินค้า
//    * @returns {Promise}
//    */
//   receiveGoods: async (id, receiveData) => {
//     try {
//       const response = await api.post(`/api/purchases/goods-receipts`, {
//         purchase_id: parseInt(id),
//         receipt_date: receiveData.receipt_date,
//         ...receiveData
//       });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// // ===============================================
// // Payments API Functions
// // ===============================================

// export const paymentsAPI = {
//   /**
//    * บันทึกการชำระเงิน
//    * @param {string|number} purchaseId - ID ของใบสั่งซื้อ
//    * @param {Object} paymentData - ข้อมูลการชำระเงิน
//    * @returns {Promise}
//    */
//   createPayment: async (purchaseId, paymentData) => {
//     try {
//       const response = await api.post(`/api/purchases/${purchaseId}/payments`, paymentData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * ดึงประวัติการชำระเงิน
//    * @param {string|number} purchaseId - ID ของใบสั่งซื้อ
//    * @returns {Promise}
//    */
//   getByPurchaseId: async (purchaseId) => {
//     try {
//       const response = await api.get(`/api/purchases/${purchaseId}/payments`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// // ===============================================
// // Suppliers API Functions
// // ===============================================

// export const suppliersAPI = {
//   /**
//    * ดึงรายการผู้จำหน่ายทั้งหมด
//    * @returns {Promise}
//    */
//   getAll: async () => {
//     try {
//       const response = await api.get('/api/purchases/suppliers');
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * เพิ่มผู้จำหน่ายใหม่
//    * @param {Object} supplierData - ข้อมูลผู้จำหน่าย
//    * @returns {Promise}
//    */
//   create: async (supplierData) => {
//     try {
//       const response = await api.post('/api/purchases/suppliers', supplierData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// // ===============================================
// // Goods Receipts API Functions
// // ===============================================

// export const goodsReceiptsAPI = {
//   /**
//    * ดึงรายการใบรับสินค้าทั้งหมด
//    * @param {Object} params - ตัวกรองข้อมูล
//    * @returns {Promise}
//    */
//   getAll: async (params = {}) => {
//     try {
//       const response = await api.get('/api/purchases/goods-receipts', { params });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   getPendingOrders: async (params = {}) => {
//     try {
//       const response = await api.get('/api/purchases/goods-receipts', { params });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * ดึงรายละเอียดใบรับสินค้าเฉพาะ
//    * @param {string|number} id - ID ของใบรับสินค้า
//    * @returns {Promise}
//    */
//   getById: async (id) => {
//     try {
//       const response = await api.get(`/api/purchases/goods-receipts/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * สร้างใบรับสินค้าใหม่
//    * @param {Object} receiptData - ข้อมูลใบรับสินค้า
//    * @returns {Promise}
//    */
//   create: async (receiptData) => {
//     try {
//       const response = await api.post('/api/purchases/goods-receipts', receiptData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * แก้ไขใบรับสินค้า
//    * @param {string|number} id - ID ของใบรับสินค้า
//    * @param {Object} receiptData - ข้อมูลใบรับสินค้าที่จะแก้ไข
//    * @returns {Promise}
//    */
//   update: async (id, receiptData) => {
//     try {
//       const response = await api.put(`/api/purchases/goods-receipts/${id}`, receiptData);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   /**
//    * ลบใบรับสินค้า
//    * @param {string|number} id - ID ของใบรับสินค้า
//    * @returns {Promise}
//    */
//   delete: async (id) => {
//     try {
//       const response = await api.delete(`/api/purchases/goods-receipts/${id}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// // ===============================================
// // Products API Functions
// // ===============================================

// export const productsAPI = {
//   /**
//    * ดึงรายการสินค้าสำหรับใบสั่งซื้อ
//    * @param {Object} params - ตัวกรองข้อมูล
//    * @returns {Promise}
//    */
//   getForPurchase: async (params = {}) => {
//     try {
//       const response = await api.get('/api/products', { params });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
//    /**
//    * ดึงรายการสินค้าสำหรับใบสั่งซื้อ
//    * @param {Object} params - ตัวกรองข้อมูล
//    * @returns {Promise}
//    */
//    search: async (keyword) => {
//     try {
//       const response = await api.get('/api/products', { search:  keyword});
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

// };

// // ===============================================
// // Utility Functions
// // ===============================================

// /**
//  * จัดรูปแบบสกุลเงิน
//  * @param {number} amount - จำนวนเงิน
//  * @returns {string}
//  */
// export const formatCurrency = (amount) => {
//   if (amount === null || amount === undefined) return '฿0.00';
//   return new Intl.NumberFormat('th-TH', {
//     style: 'currency',
//     currency: 'THB',
//     minimumFractionDigits: 2,
//   }).format(amount);
// };

// /**
//  * จัดรูปแบบวันที่
//  * @param {string|Date} date - วันที่
//  * @returns {string}
//  */
// export const formatDate = (date) => {
//   if (!date) return '-';
//   return new Intl.DateTimeFormat('th-TH', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//   }).format(new Date(date));
// };

// /**
//  * จัดรูปแบบวันที่และเวลา
//  * @param {string|Date} date - วันที่และเวลา
//  * @returns {string}
//  */
// export const formatDateTime = (date) => {
//   if (!date) return '-';
//   return new Intl.DateTimeFormat('th-TH', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//   }).format(new Date(date));
// };

// /**
//  * จัดการ Error จาก API
//  * @param {Error} error - Error object
//  * @returns {string}
//  */
// export const handleAPIError = (error) => {
//   if (error.response) {
//     // Server responded with error status
//     const { status, data } = error.response;
    
//     if (status === 401) {
//       return 'ไม่ได้รับอนุญาต กรุณาเข้าสู่ระบบใหม่';
//     } else if (status === 403) {
//       return 'ไม่มีสิทธิ์เข้าถึงข้อมูลนี้';
//     } else if (status === 404) {
//       return 'ไม่พบข้อมูลที่ต้องการ';
//     } else if (status === 422) {
//       return data.message || 'ข้อมูลไม่ถูกต้อง';
//     } else if (status >= 500) {
//       return 'เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง';
//     }
    
//     return data.message || 'เกิดข้อผิดพลาดไม่ทราบสาเหตุ';
//   } else if (error.request) {
//     // Network error
//     return 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต';
//   } else {
//     // Other error
//     return error.message || 'เกิดข้อผิดพลาดไม่ทราบสาเหตุ';
//   }
// };


// export const PO_STATUS = {
//   DRAFT: 'draft',
//   PENDING: 'pending',
//   APPROVED: 'approved',
//   RECEIVED: 'received',
//   COMPLETED: 'completed',
//   CANCELLED: 'cancelled',
// };

// // สถานะของใบรับสินค้า
// export const GR_STATUS = {
//   DRAFT: 'draft',
//   PENDING: 'pending',
//   CONFIRMED: 'confirmed',
//   CANCELLED: 'cancelled',
// };

// // ประเภทการเคลื่อนไหวสต็อก
// export const STOCK_MOVEMENT_TYPES = {
//   PURCHASE: 'purchase',
//   SALE: 'sale',
//   ADJUSTMENT: 'adjustment',
//   TRANSFER: 'transfer',
//   RETURN: 'return',
// };

// // ประเภทการชำระเงิน
// export const PAYMENT_TYPES = {
//   CASH: 'cash',
//   CREDIT: 'credit',
//   TRANSFER: 'transfer',
//   CHECK: 'check',
// };


// // Export default
// export default {
//   purchasesAPI,
//   paymentsAPI,
//   suppliersAPI,
//   goodsReceiptsAPI,
//   productsAPI,
//   formatCurrency,
//   formatDate,
//   formatDateTime,
//   handleAPIError,
// };




// // สถานะของใบสั่งซื้อ
// // export const PO_STATUS = {
// //   DRAFT: 'draft',
// //   PENDING: 'pending',
// //   APPROVED: 'approved',
// //   RECEIVED: 'received',
// //   COMPLETED: 'completed',
// //   CANCELLED: 'cancelled',
// // };

// // // สถานะของใบรับสินค้า
// // export const GR_STATUS = {
// //   DRAFT: 'draft',
// //   PENDING: 'pending',
// //   CONFIRMED: 'confirmed',
// //   CANCELLED: 'cancelled',
// // };

// // // ประเภทการเคลื่อนไหวสต็อก
// // export const STOCK_MOVEMENT_TYPES = {
// //   PURCHASE: 'purchase',
// //   SALE: 'sale',
// //   ADJUSTMENT: 'adjustment',
// //   TRANSFER: 'transfer',
// //   RETURN: 'return',
// // };

// // // ประเภทการชำระเงิน
// // export const PAYMENT_TYPES = {
// //   CASH: 'cash',
// //   CREDIT: 'credit',
// //   TRANSFER: 'transfer',
// //   CHECK: 'check',
// // };

// ===============================================
// Purchase Service API Client
// สำหรับเชื่อมต่อกับ Backend Purchase APIs
// ===============================================
import { Search } from 'lucide-react';
import api from '../utils/api';

// ===============================================
// Purchase API Functions
// ===============================================

export const purchasesAPI = {
  /**
   * ดึงรายการใบสั่งซื้อทั้งหมด
   * @param {Object} params - ตัวกรองข้อมูล
   * @returns {Promise}
   */
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/api/purchases', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ดึงรายละเอียดใบสั่งซื้อเฉพาะ
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @returns {Promise}
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/purchases/${id}`);
      console.log('response', response);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * สร้างใบสั่งซื้อใหม่
   * @param {Object} purchaseData - ข้อมูลใบสั่งซื้อ
   * @returns {Promise}
   */
  create: async (purchaseData) => {
    try {
      const response = await api.post('/api/purchases/orders', purchaseData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * แก้ไขใบสั่งซื้อ
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @param {Object} purchaseData - ข้อมูลใบสั่งซื้อที่จะแก้ไข
   * @returns {Promise}
   */
  update: async (id, purchaseData) => {
    try {
      const response = await api.put(`/api/purchases/orders/${id}`, purchaseData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * เปลี่ยนสถานะใบสั่งซื้อ
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @param {string} status - สถานะใหม่
   * @param {string} notes - หมายเหตุ
   * @returns {Promise}
   */
  updateStatus: async (id, status, notes = '') => {
    try {
      const response = await api.patch(`/api/purchases/${id}/status`, {
        status,
        notes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ลบใบสั่งซื้อ
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @returns {Promise}
   */
  delete: async (id) => {
    try {
      const response = await api.delete(`/api/purchases/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * รับสินค้าเข้าคลัง
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @param {Object} receiveData - ข้อมูลการรับสินค้า
   * @returns {Promise}
   */
  receiveGoods: async (id, receiveData) => {
    try {
      const response = await api.post(`/api/purchases/goods-receipts`, {
        purchase_id: parseInt(id),
        receipt_date: receiveData.receipt_date,
        ...receiveData
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// ===============================================
// Payments API Functions
// ===============================================

export const paymentsAPI = {
  /**
   * บันทึกการชำระเงิน
   * @param {string|number} purchaseId - ID ของใบสั่งซื้อ
   * @param {Object} paymentData - ข้อมูลการชำระเงิน
   * @returns {Promise}
   */
  createPayment: async (purchaseId, paymentData) => {
    try {
      const response = await api.post(`/api/purchases/${purchaseId}/payments`, paymentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ดึงประวัติการชำระเงิน
   * @param {string|number} purchaseId - ID ของใบสั่งซื้อ
   * @returns {Promise}
   */
  getByPurchaseId: async (purchaseId) => {
    try {
      const response = await api.get(`/api/purchases/${purchaseId}/payments`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// ===============================================
// Suppliers API Functions
// ===============================================

export const suppliersAPI = {
  /**
   * ดึงรายการผู้จำหน่ายทั้งหมด
   * @returns {Promise}
   */
  getAll: async () => {
    try {
      const response = await api.get('/api/purchases/suppliers');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * เพิ่มผู้จำหน่ายใหม่
   * @param {Object} supplierData - ข้อมูลผู้จำหน่าย
   * @returns {Promise}
   */
  create: async (supplierData) => {
    try {
      const response = await api.post('/api/purchases/suppliers', supplierData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// ===============================================
// Goods Receipts API Functions
// ===============================================

export const goodsReceiptsAPI = {
  /**
   * ดึงรายการใบรับสินค้าทั้งหมด
   * @param {Object} params - ตัวกรองข้อมูล
   * @returns {Promise}
   */
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/api/purchases/goods-receipts', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPendingOrders: async (params = {}) => {
    try {
      const response = await api.get('/api/purchases/pending-orders', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ดึงรายละเอียด pending order พร้อมสินค้าที่ยังรับไม่ครบ
   * @param {string|number} id - ID ของใบสั่งซื้อ
   * @returns {Promise}
   */
  getPendingOrderById: async (id) => {
    try {
      const response = await api.get(`/api/purchases/pending-orders/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ดึงรายละเอียดใบรับสินค้าเฉพาะ
   * @param {string|number} id - ID ของใบรับสินค้า
   * @returns {Promise}
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/purchases/goods-receipts/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * สร้างใบรับสินค้าใหม่
   * @param {Object} receiptData - ข้อมูลใบรับสินค้า
   * @returns {Promise}
   */
  create: async (receiptData) => {
    try {
      const response = await api.post('/api/purchases/goods-receipts', receiptData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * แก้ไขใบรับสินค้า
   * @param {string|number} id - ID ของใบรับสินค้า
   * @param {Object} receiptData - ข้อมูลใบรับสินค้าที่จะแก้ไข
   * @returns {Promise}
   */
  update: async (id, receiptData) => {
    try {
      const response = await api.put(`/api/purchases/goods-receipts/${id}`, receiptData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * ลบใบรับสินค้า
   * @param {string|number} id - ID ของใบรับสินค้า
   * @returns {Promise}
   */
  delete: async (id) => {
    try {
      const response = await api.delete(`/api/purchases/goods-receipts/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// ===============================================
// Products API Functions
// ===============================================

export const productsAPI = {
  /**
   * ดึงรายการสินค้าสำหรับใบสั่งซื้อ
   * @param {Object} params - ตัวกรองข้อมูล
   * @returns {Promise}
   */
  getForPurchase: async (params = {}) => {
    try {
      const response = await api.get('/api/products', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
   /**
   * ดึงรายการสินค้าสำหรับใบสั่งซื้อ
   * @param {Object} params - ตัวกรองข้อมูล
   * @returns {Promise}
   */
   search: async (keyword) => {
    try {
      const response = await api.get('/api/products', { search:  keyword});
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

// ===============================================
// Utility Functions
// ===============================================

/**
 * จัดรูปแบบสกุลเงิน
 * @param {number} amount - จำนวนเงิน
 * @returns {string}
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '฿0.00';
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 2,
  }).format(amount);
};

/**
 * จัดรูปแบบวันที่
 * @param {string|Date} date - วันที่
 * @returns {string}
 */
export const formatDate = (date) => {
  if (!date) return '-';
  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(date));
};

/**
 * จัดรูปแบบวันที่และเวลา
 * @param {string|Date} date - วันที่และเวลา
 * @returns {string}
 */
export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(date));
};

/**
 * จัดการ Error จาก API
 * @param {Error} error - Error object
 * @returns {string}
 */
export const handleAPIError = (error) => {
  if (error.response) {
    // Server responded with error status
    const { status, data } = error.response;
    
    if (status === 401) {
      return 'ไม่ได้รับอนุญาต กรุณาเข้าสู่ระบบใหม่';
    } else if (status === 403) {
      return 'ไม่มีสิทธิ์เข้าถึงข้อมูลนี้';
    } else if (status === 404) {
      return 'ไม่พบข้อมูลที่ต้องการ';
    } else if (status === 422) {
      return data.message || 'ข้อมูลไม่ถูกต้อง';
    } else if (status >= 500) {
      return 'เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง';
    }
    
    return data.message || 'เกิดข้อผิดพลาดไม่ทราบสาเหตุ';
  } else if (error.request) {
    // Network error
    return 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต';
  } else {
    // Other error
    return error.message || 'เกิดข้อผิดพลาดไม่ทราบสาเหตุ';
  }
};


export const PO_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  RECEIVED: 'received',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

// สถานะของใบรับสินค้า
export const GR_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
};

// ประเภทการเคลื่อนไหวสต็อก
export const STOCK_MOVEMENT_TYPES = {
  PURCHASE: 'purchase',
  SALE: 'sale',
  ADJUSTMENT: 'adjustment',
  TRANSFER: 'transfer',
  RETURN: 'return',
};

// ประเภทการชำระเงิน
export const PAYMENT_TYPES = {
  CASH: 'cash',
  CREDIT: 'credit',
  TRANSFER: 'transfer',
  CHECK: 'check',
};


// Export default
export default {
  purchasesAPI,
  paymentsAPI,
  suppliersAPI,
  goodsReceiptsAPI,
  productsAPI,
  formatCurrency,
  formatDate,
  formatDateTime,
  handleAPIError,
};




// สถานะของใบสั่งซื้อ
// export const PO_STATUS = {
//   DRAFT: 'draft',
//   PENDING: 'pending',
//   APPROVED: 'approved',
//   RECEIVED: 'received',
//   COMPLETED: 'completed',
//   CANCELLED: 'cancelled',
// };

// // สถานะของใบรับสินค้า
// export const GR_STATUS = {
//   DRAFT: 'draft',
//   PENDING: 'pending',
//   CONFIRMED: 'confirmed',
//   CANCELLED: 'cancelled',
// };

// // ประเภทการเคลื่อนไหวสต็อก
// export const STOCK_MOVEMENT_TYPES = {
//   PURCHASE: 'purchase',
//   SALE: 'sale',
//   ADJUSTMENT: 'adjustment',
//   TRANSFER: 'transfer',
//   RETURN: 'return',
// };

// // ประเภทการชำระเงิน
// export const PAYMENT_TYPES = {
//   CASH: 'cash',
//   CREDIT: 'credit',
//   TRANSFER: 'transfer',
//   CHECK: 'check',
// };

